"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subnav = void 0;
const types_1 = require("@air/types");
const request_1 = require("./request");
function getSubnav(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.subnav, {
            workspaceId,
        });
    });
}
function listSubnavBoardSortOptions(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.subnav, {
            endpoint: `boardSortOptions`,
            workspaceId,
        });
    });
}
function updateSubnav(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, update, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.subnav, {
            method: 'PATCH',
            body: update,
            workspaceId,
        });
    });
}
exports.Subnav = {
    getSubnav,
    listSubnavBoardSortOptions,
    updateSubnav,
};
//# sourceMappingURL=subnav.js.map